import BaseService from './base-service'
const baseService = new BaseService();

class AuthService {
  static setAuthToken(token : string){
    baseService.setToken(token);
  }
}

export default AuthService;